<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('totalScoreGenerate.academicYear')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.ac_year_id"
            :options="academic_year_list"
          ></a-select>
          <div class="validate" v-if="errors.has('ac_year_id')">
            {{ errors.first('ac_year_id') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('totalScoreGenerate.mainProgram')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.acp_id"
            :options="main_program_list"
            :disabled="!model.ac_year_id"
            @change="onMainProgramChange"
          ></a-select>
          <div class="validate" v-if="errors.has('acp_id')">
            {{ errors.first('acp_id') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('totalScoreGenerate.subProgram')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.acps_id"
            :options="model.sub_program_list"
            :disabled="!model.acp_id"
          ></a-select>
          <div class="validate" v-if="errors.has('acps_id')">
            {{ errors.first('acps_id') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('totalScoreGenerate.scoringCycle')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.scoring_cycle_id"
            :options="scoringCycle"
            @change="onScoringCyleChange"
          ></a-select>
          <div class="validate" v-if="errors.has('scoring_cycle_id')">
            {{ errors.first('scoring_cycle_id') }}
          </div>
        </div>
      </div>
      <div class="row form-group" v-if="model.scoring_cycle_id != 4">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('totalScoreGenerate.cycleValue')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.cycle_value"
            :options="cycle_value_list"
          ></a-select>
          <div class="validate" v-if="errors.has('cycle_value')">
            {{ errors.first('cycle_value') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('totalScoreGenerate.grade')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.grade_id_list"
            mode="multiple"
            optionFilterProp="children"
            :showSearch="true"
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            :options="grade_list"
          ></a-select>
          <div class="validate" v-if="errors.has('grade_id_list')">
            {{ errors.first('grade_id_list') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right ts-whitespace-no-wrap">
          <ts-button class="mr-2" @click.prevent="$emit('closeModal')">{{
            $t('cancel')
          }}</ts-button>
          <ts-button color="primary" @click.prevent="onSave">
            {{ $t('totalScoreGenerate.generate') }}
          </ts-button>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
export default {
  data () {
    return {
      errors: new Errors(),
      academic_year_list: [],
      main_program_list: [],
      grade_list: [],
      cycle_value_list: [],
      loading: false,
      model: {
        ac_year_id: '',
        acp_id: '',
        acps_id: '',
        scoring_cycle_id: '',
        cycle_value: '',
        sub_program_list: [],
        grade_id_list: []
      }
    }
  },
  computed: {
    scoringCycle () {
      let acps = this.model.sub_program_list.find(m => m.value == this.model.acps_id)
      if (acps) {
        return acps.scoring_cyles.map(el => ({
          value: el.scoring_cycle_id,
          label: el.scoring_cycle_name
        }))
      }
      return []
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapActions('generateTotalScore', ['formViewModel', 'generateTotalAvg']),
    async fetchData () {
      this.loading = true
      this.formViewModel()
        .then(response => {
          this.main_program_list = response.academicMain.map(el => ({
            value: el.acp_id,
            label: el.acp_name_foreign
          }))
          this.academic_year_list = response.academicYear.map(el => ({
            value: el.ac_year_id,
            label:
              el.ac_year +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : ' ( Next ) ')
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    onMainProgramChange (value) {
      this.loading = true
      this.model.acps_id = ''
      this.model.scoring_cycle_id = ''
      this.model.cycle_value = ''
      this.model.sub_program_list = []
      this.model.grade_id_list = []
      this.formViewModel({
        fnName: 'academicSub',
        acp_id: value
      })
        .then(response => {
          this.model.sub_program_list = response.academicSub.map(el => ({
            value: el.acps_id,
            label: el.acps_name_foreign,
            scoring_cyles: el.scoring_cyles
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
      this.formViewModel({
        fnName: 'grade',
        acp_id: value
      })
        .then(response => {
          this.grade_list = response.grade.map(el => ({
            value: el.grade_id,
            label: el.grade_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    onScoringCyleChange (value) {
      this.loading = true
      this.model.cycle_value = ''
      this.formViewModel({
        fnName: 'cycleValue',
        scoring_cycle_id: value
      })
        .then(response => {
          this.cycle_value_list = response.cycleValue.map(el => ({
            value: parseInt(el.scoring_cycle_value),
            label: el.scoring_cycle_description
              ? el.scoring_cycle_description
              : 'N/A'
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    onSave () {
      this.loading = true
      this.generateTotalAvg(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('closeModal')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSaveNew () {
      this.loading = true
      this.generateTotalAvg(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput () {
      this.model.ac_year_id = ''
      this.model.acp_id = ''
      this.model.acps_id = ''
      this.model.scoring_cycle_id = ''
      this.model.cycle_value = ''
      this.model.sub_program_list = [],
      this.model.grade_id_list = []
    }
  }
}
</script>
